module.exports = __webpack_public_path__ + "img/daizy_river.c04aefc2.jpg";